/**
 * A dictionary containing error messages to show in SsnTextboxBox and SsnTextboxBox.Field
 */
export const errorMessages: Record<string, string> = {
  "invalid length": "SSN value should be exactly 9 digits",
  required: "SSN is required",
  "invalid format": "SSN must contain only numbers",
  "invalid pattern": "SSN contains invalid number patterns",
};
